import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Source of a log line — identifies which producer emitted the event.
 *
 * - `bootstrap`: Mac binary installer / Hetzner provisioning script
 * - `provisioning`: server-side provisioning workflow
 * - `agent`: management agent running on the installed node
 * - `system`: server-emitted system event
 *
 * @since 1.0.0
 */
export const InstallationLogSource = Schema.Literal(
  "bootstrap",
  "provisioning",
  "agent",
  "system",
);
export type InstallationLogSource = Schema.Schema.Type<typeof InstallationLogSource>;

/**
 * Log severity level.
 *
 * @since 1.0.0
 */
export const InstallationLogLevel = Schema.Literal(
  "debug",
  "info",
  "warn",
  "error",
);
export type InstallationLogLevel = Schema.Schema.Type<typeof InstallationLogLevel>;

/**
 * Runtime log line emitted by the installer or management agent.
 *
 * Append-only buffer — replayed by install-detail consumers and used for
 * post-mortem on failed provisioning runs.
 *
 * @since 1.0.0
 */
export class InstallationLog extends Model.Class<InstallationLog>("InstallationLog")({
  id: Model.Generated(Schema.String),
  installationId: Schema.String,
  source: InstallationLogSource,
  level: InstallationLogLevel,
  message: Schema.String,
  meta: Schema.NullOr(Schema.Unknown),
  ts: Model.DateTimeFromDate,
  createdAt: Model.DateTimeInsertFromDate,
}) {}
